import genReducer from '../core/reducer';
import types from './types';
import initialState from './initialState';

export const VISITORS_MODEL = 'visitors';

export default genReducer(types, initialState);
